export default __webpack_public_path__ + "static/media/fireworks.e482de27.png";